<template>
  <ul class="left_pages">
    <li
      v-for="(item,i) in $store.state.app.pages"
      :key="i"
      :class="$store.state.app.now_page == item.name ? 'select_page' : ''"
      @click="jump(item)"
    >
      {{item.title}}
      <!-- <router-link :to="item.name">{{item.title}}</router-link> -->
    </li>
  </ul>
</template>

<script>
export default {
  name: "page",
  data() {
    return {};
  },
  methods: {
    jump(item) {
      this.templet.is_jump(() => {
        this.$router.push({
          name: item.name
        });
      });
    }
  },

  mounted() {
    
  }
};
</script>

<style scoped lang="scss">
.left_pages {
  width: 100%;
  padding: 0 15px;
  li {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #f2f2f2;
    line-height: 50px;
    font-size: 13px;

    padding-left: 10px;
    cursor: pointer;
    a {
      display: block;
      width: 100%;
      height: 100%;
      color: #333;
    }
  }
  li:hover a {
    color: #2ba0e8;
  }
  .select_page {
    color: #2ba0e8;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/left_sidebar/page.vue